import { Suspense } from "react";
import "styles/App.css";
import Spinner from "shared/layout/Spinner";
import { HelmetProvider } from "react-helmet-async";
import AppRoutes from "shared/layout/AppRoutes";
import ThemeProvider from "@mui/material/styles/ThemeProvider";
import myCustomTheme from "shared/theme/App.theme";
import { ToastProvider } from "react-toast-notifications";
import "aos/dist/aos.css";

function App() {
  return (
    <Suspense fallback={<Spinner />}>
      <ThemeProvider theme={myCustomTheme}>
        <ToastProvider placement="bottom-right" autoDismiss>
          <HelmetProvider>
            <Spinner />
            <AppRoutes />
          </HelmetProvider>
        </ToastProvider>
      </ThemeProvider>
    </Suspense>
  );
}

export default App;
